export class ConversationExportCategorySelectionChange {
  static readonly type = '[ConversationExportPreference] ConversationExportCategorySelectionChange';

  constructor(
    public fingerprint: string,
    public allSelected: boolean,
    public queryIds: number[],
  ) {}
}
